export default {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'reaction_delay', component: 'reaction_delay_g2' },
		{ title: 'voltmeter_settings', component: 'voltmeter_settings_per_id_g2' },
		{
			title: 'operational_counters',
			component: 'operational_counters_g2',
			requires_operational_counters: true,
		},
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
